import type { UnitType } from '@/types';

/**
 * Whether units of the given type use (and therefore should display) a unit number.
 *
 * Driven by the unit type's `fieldConfig.requireNumber`. When the unit type — or its
 * field config — is unknown, we default to `true` so that existing numbers keep showing
 * rather than disappearing unexpectedly for legacy units.
 */
export function unitTypeRequiresNumber(
  unitType?: Pick<UnitType, 'fieldConfig'> | null,
): boolean {
  return unitType?.fieldConfig?.requireNumber ?? true;
}

/**
 * Resolve whether a unit (identified by its `typeId`) should display a unit number,
 * given the list of platform unit types.
 */
export function unitDisplaysNumber(
  typeId: string | undefined | null,
  unitTypes: UnitType[] | undefined | null,
): boolean {
  if (!typeId || !unitTypes?.length) {
    return true;
  }
  return unitTypeRequiresNumber(unitTypes.find((ut) => ut.id === typeId));
}
